import React from "react";
import { useCompany } from "../../context/CompanyContext";

export default function PayrollTopbar() {
  const { company } = useCompany();

  return (
    <div className="payroll-topbar">
      <div>
        <h1>Payroll Management</h1>
        <p>
          Manage payroll operations for{" "}
          <strong>{company?.company_name || "your company"}</strong>
        </p>
      </div>
    </div>
  );
}
